import useEnv from '../composables/useEnv'
import useRestNode from '../composables/useRestNode'

/**
 * Service for obtaining networks based on marketing group Id from API Safe Link
 */
export default function useMarketingGroupService() {

    const { get } = useRestNode()
    const { safelinkEndpoint, networkServiceEndpoint } = useEnv()

    const loadNetworkData = async (marketingGroupId) => {

        if ( !marketingGroupId ) return null

        try {
            const url = `${safelinkEndpoint}/marketing-group/${marketingGroupId}`
            const links = await get(url.toString())
            const networks = []
            // FYI, couldnot use foreach with arrow function here, which needs its 'async', 
            // causing empty [] of networks returned
            for (let link of links.value) {
                const networkId = link.networkId
                const networkUrl = `${networkServiceEndpoint}/network-detail/network/${networkId}`
                const networkInfo = await get(networkUrl.toString())
                const networkName = networkInfo.value?.name
                // in case a network is removed from CPN, and has not been removed by SafeLink Admin
                if (!networkName) {
                  continue
                }
                networks.push({safelink: link.name, networkId, networkName})
            }
            return networks
        }catch (error) {
            return {
                status: 'Error',
                message: error,
            }
        }
    }

    const fns = { loadNetworkData}

    return fns
}